import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
export default function Footer(): JSX.Element {
  return <section id="footer" className="bg-secondary text-secondary-foreground py-16 border-t border-secondary-foreground/10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col items-center md:items-start">
            <img src="/img/IMG_1410.png" alt="Banquetes Orzuna" className="object-contain mb-6 !w-[150px] !h-[150px]" />
          </div>

          {}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg font-serif font-semibold mb-6 text-secondary-foreground">
              Explore
            </h3>
            <nav className="flex flex-col gap-4 text-center md:text-left">
              <Link to="#" className="text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300">
                About Us
              </Link>
              <Link to="#" className="text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300">
                Menu Highlights
              </Link>
              <Link to="#" className="text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300">
                FAQ
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg font-serif font-semibold mb-6 text-secondary-foreground">
              Contact
            </h3>
            <div className="flex flex-col gap-4 mb-8 text-center md:text-left w-full items-center md:items-start">
              <div className="flex items-center gap-3 text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300 cursor-default">
                <MapPin className="w-5 h-5 shrink-0 text-chart-3" />
                <span>Indianapolis, Indiana</span>
              </div>
              <Link to="tel:+1317-252-3882" className="flex items-center gap-3 text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300">
                <Phone className="w-5 h-5 shrink-0 text-chart-3" />
                <span>317-252-3882</span>
              </Link>
              <Link to="https://form.jotform.com/260726417957063" newTab className="flex items-center gap-3 text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300">
                <Mail className="w-5 h-5 shrink-0 text-chart-3" />
                <span>Ordene Aqui!</span>
              </Link>
            </div>
            <div className="flex gap-6 !w-[120px] !h-[25px]">
              <Link to="https://www.instagram.com/lorzuna?igsh=MW0wc2d4eWt1bXgxaw%3D%3D&utm_source=qr" newTab className="text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300 hover:scale-110 transform">
                <Instagram className="w-6 h-6" />
                <span className="sr-only">Instagram</span>
              </Link>
              <Link to="https://www.facebook.com/share/1CBLPAwi5h/?mibextid=wwXIfr" newTab className="text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300 hover:scale-110 transform">
                <Facebook className="w-6 h-6" />
                <span className="sr-only">Facebook</span>
              </Link>
              <Link to="https://www.tiktok.com/@laura37banquetesorzuna?_r=1&_t=ZT-94idZmCkrF7" newTab className="text-secondary-foreground/60 hover:text-secondary-foreground transition-colors duration-300 hover:scale-110 transform">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                </svg>
                <span className="sr-only">TikTok</span>
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-secondary-foreground/20 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-secondary-foreground/60">
          <p className="text-center md:text-left">
            &copy; {new Date().getFullYear()} Banquetes Orzuna. All rights reserved. Built by <Link to="https://horizonmediamanagementllc.com/" newTab className="hover:text-secondary-foreground underline transition-colors">Horizon Media Management LLC</Link>
          </p>
          <p className="font-medium tracking-wide">Hecho Con Pasion </p>
        </div>
      </div>
    </section>;
}